import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import HamburgerMenu from "./HamburgerMenu";
import { colors } from "../../utils/colors";

interface NavbarProps {
  token?: string | null;
}

export default function Navbar(props: NavbarProps): React.JSX.Element {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="static"
        sx={{
          backgroundColor: colors.cardBackground,
          color: colors.primaryText,
          boxShadow: "none",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={11}>
            <Toolbar>Yard Manager Beta</Toolbar>
          </Grid>
          {props.token ? (
            <Grid item xs={1}>
              <HamburgerMenu token={props.token} />
            </Grid>
          ) : null}
        </Grid>
      </AppBar>
    </Box>
  );
}
